const EVENT_MIN_LEAD_TIME_MS = 2 * 60 * 1000;

const padDateTimePart = (value: number): string => String(value).padStart(2, '0');

export function getEventScheduleValidationMessage(): string {
  return 'Event must be scheduled at least 2 minutes in the future.';
}

export function parseEventScheduleInput(value: string): Date | null {
  if (!value) {
    return null;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function hasMinimumEventLeadTime(
  value: string,
  now: Date = new Date(),
  minLeadTimeMs: number = EVENT_MIN_LEAD_TIME_MS,
): boolean {
  const scheduledDate = parseEventScheduleInput(value);
  if (!scheduledDate) {
    return false;
  }

  return scheduledDate.getTime() - now.getTime() >= minLeadTimeMs;
}

export function getEventMinScheduleDate(
  now: Date = new Date(),
  minLeadTimeMs: number = EVENT_MIN_LEAD_TIME_MS,
): Date {
  return new Date(now.getTime() + minLeadTimeMs);
}

function ceilToNextMinute(date: Date): Date {
  const roundedDate = new Date(date);
  if (roundedDate.getSeconds() !== 0 || roundedDate.getMilliseconds() !== 0) {
    roundedDate.setMinutes(roundedDate.getMinutes() + 1);
  }
  roundedDate.setSeconds(0, 0);
  return roundedDate;
}

export function formatDateTimeLocalInputValue(date: Date): string {
  return [
    date.getFullYear(),
    padDateTimePart(date.getMonth() + 1),
    padDateTimePart(date.getDate()),
  ].join('-') + `T${padDateTimePart(date.getHours())}:${padDateTimePart(date.getMinutes())}`;
}

export function getEventMinDateTimeInputValue(now: Date = new Date()): string {
  return formatDateTimeLocalInputValue(ceilToNextMinute(getEventMinScheduleDate(now)));
}

export { EVENT_MIN_LEAD_TIME_MS };
